/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { sectionAvailabilitySchema } from "./sectionAvailabilitySchema.ts";

export const reserveAvailabilityResponseSchema = z.object({
	date: z.iso.date(),
	duration_minutes: z.int(),
	slot_step_minutes: z.int(),
	sections: z.array(sectionAvailabilitySchema),
});
